import { __ } from "@wordpress/i18n";
import apiFetch from '@wordpress/api-fetch';
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import withForm from '../../layouts/withForm';
const ActivityLog = () => {
    const [logs, setLogs] = useState([]);
    const [filters, setFilters] = useState({
        user_name: '',
        status: '',
        action_by: '',
        ip_address: '',
        created_date: '',
    });
    
    useEffect(() => {
        const getLogs = async () => {
            try {
                const response = await apiFetch({
                    path: '/ultimate-security/v1/get-passkeys-activity-logs',
                    method: 'GET'
                });
                setLogs(response);
            } catch (error) {
                // console.error(error);
            }
        };
        getLogs();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    const columns = [
        {
            id: 'user',
            name: __('User', 'ultimate-security'),
            cell: row => (
                <div className="d-flex flex-wrap align-items-center gap-2">
                    <span><b>{row.user_email}</b></span>
                </div>
            ),
        },
        {
            id: 'description',
            name: __('Description', 'ultimate-security'),
            selector: row => row.description,
            sortable: true,
        },
        {
            id: 'active',
            name: __('Active', 'ultimate-security'),
            selector: row => row.is_active === "1" ? __('Active', 'ultimate-security') : __('Inactive', 'ultimate-security'),
            sortable: true,
        },
        {
            id: 'ip-address',
            name: __('IP Address', 'ultimate-security'),
            selector: row => row.ip_address,
            sortable: true,
        },
        {
            id: 'created-date',
            name: __('Created Date', 'ultimate-security'),
            selector: row => row.created_at,
            sortable: true,
        },
    ];

    // Filter the logs data based on current filters
    const filteredData = logs?.data?.filter((item) => {
        const matchUser = filters.user_name === '' || item.user_email.toLowerCase().includes(filters.user_name.toLowerCase());
        
        const matchStatus = filters.status === '' || item.is_active === filters.status;
        
        const matchActionBy = filters.action_by === '' || item.description.toUpperCase().includes(filters.action_by);
        
        const matchIpAddress = filters.ip_address === '' || item.ip_address.includes(filters.ip_address);
        
        // Date filtering - extract date part from datetime string
        const createdDateMatch = !filters.created_date || item.created_at.split(' ')[0] === filters.created_date;
        
        return matchUser && matchStatus && matchActionBy && matchIpAddress && createdDateMatch;
    }) || [];

    return (
        <>
            <div className="setting-unit">
                <div className="user-datatable datatable-unit">
                    <div className="filter-wrapper row g-3 align-items-center mb-4">
                        {/* User Field */}
                        <div className="col-md-2">
                            <label htmlFor="user_name" className="form-label fw-bold">
                                {__('User', 'ultimate-security')}
                            </label>
                            <input
                                id="user_name"
                                type="text"
                                name="user_name"
                                className="form-control"
                                value={filters.user_name}
                                onChange={handleInputChange}
                                placeholder="Enter email"
                            />
                        </div>

                        {/* Status Field */}
                        <div className="col-md-2">
                            <label htmlFor="status" className="form-label fw-bold">
                                {__('Status', 'ultimate-security')}
                            </label>
                            <select
                                id="status"
                                name="status"
                                className="form-control"
                                value={filters.status}
                                onChange={handleInputChange}
                            >
                                <option value="">{__('Any', 'ultimate-security')}</option>
                                <option value="1">{__('Active', 'ultimate-security')}</option>
                                <option value="0">{__('Inactive', 'ultimate-security')}</option>
                            </select>
                        </div>

                        {/* Action By Field */}
                        <div className="col-md-2">
                            <label htmlFor="action_by" className="form-label fw-bold">
                                {__('Action By', 'ultimate-security')}
                            </label>
                            <select
                                id="action_by"
                                name="action_by"
                                className="form-control"
                                value={filters.action_by}
                                onChange={handleInputChange}
                            >
                                <option value="">{__('Any', 'ultimate-security')}</option>
                                <option value="LOGIN">{__('Login', 'ultimate-security')}</option>
                                <option value="REGISTER">{__('Register', 'ultimate-security')}</option>
                                <option value="ACTIVATE">{__('Activate', 'ultimate-security')}</option>
                                <option value="DEACTIVATE">{__('Deactivate', 'ultimate-security')}</option>
                                <option value="REMOVE">{__('Remove', 'ultimate-security')}</option>
                            </select>
                        </div>

                        {/* IP Address Field */}
                        <div className="col-md-3">
                            <label htmlFor="ip_address" className="form-label fw-bold">
                                {__('IP Address', 'ultimate-security')}
                            </label>
                            <input
                                id="ip_address"
                                type="text"
                                name="ip_address"
                                className="form-control"
                                value={filters.ip_address}
                                onChange={handleInputChange}
                                placeholder={__('Enter IP address', 'ultimate-security')}
                            />
                        </div>

                        {/* Created Date Field */}
                        <div className="col-md-3">
                            <label htmlFor="created_date" className="form-label fw-bold">
                                {__('Created Date', 'ultimate-security')}
                            </label>
                            <input
                                id="created_date"
                                type="date"
                                name="created_date"
                                className="form-control"
                                value={filters.created_date}
                                onChange={handleInputChange}
                                placeholder={__('Select date', 'ultimate-security')}
                            />
                        </div>
                    </div>           
                    
                    <div className="table-wrapper">
                        <DataTable
                            columns={columns}
                            data={filteredData} // Use filtered data
                            pagination
                            paginationPerPage={5} // Default to 5 rows per page
                            paginationRowsPerPageOptions={[5, 10, 15, 25, 50]} // Options with 5 first
                            dense
                            responsive
                        />
                    </div> 
                </div> 
            </div>
        </>
    )
}
export default withForm(ActivityLog);